/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


//Product info table append the extra info table 
setTimeout(()=>{
  let parentTable = document.getElementById('parentTableProductInfo');
  if(parentTable){
     let parentTableList = parentTable.querySelector("tbody");
    let childTable = document.getElementById('productInfoExtra');
    let childTableList = childTable.querySelectorAll("tr");
      childTableList.forEach(i=>{
        parentTableList.append(i);
  })
  }
 
},1000)


$(document).ready(function() {
  $("video[data-video-src-deferred]").each(function() {
    var videoSrc = $(this).data("video-src-deferred");
    var videoElement = $(this);
    setTimeout(function() {
      videoElement.attr("src", videoSrc);
    }, 3000); // Delay of 2500 milliseconds (2.5 seconds)
  });
});

// Function to get primary locale 
function getPrimaryLocale(hostname) {
    // Default to Dutch for .nl and .be domains, or for .com domains serving primarily Dutch content
    if (hostname.endsWith('.nl') || hostname.endsWith('.be') || hostname.endsWith('.com')) {
      return 'nl';
    } 
    // Default to French for .fr domains
    else if (hostname.endsWith('.fr')) {
      return 'fr';
    }
    return 'nl'; // Default locale 
}